import { render, staticRenderFns } from "./TextArrow.vue?vue&type=template&id=f3198f6c&scoped=true&"
import script from "./TextArrow.vue?vue&type=script&lang=js&"
export * from "./TextArrow.vue?vue&type=script&lang=js&"
import style0 from "./TextArrow.vue?vue&type=style&index=0&id=f3198f6c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f3198f6c",
  null
  
)

export default component.exports